<template>
  <section id="cotizacion">
    <div class="row" v-if="multimedia[0] != undefined">
      <div class="col-sm-12 cotitrack-fondo extranet-fondo-2">
        <div class="row">
          <div class="col-sm-6">
            <div class="cotitrack-contenido extranet-contenidor">
              <div>
                <h1>
                  <strong>{{ multimedia[0].title_multimedia }}</strong>
                </h1>
              </div>
              <span v-html="multimedia[0].desc_multimedia"></span>
              <br />
              <div class="cotitrack-texto">
                <a
                  id="confirm2"
                  :href="multimedia[0].link_button_multimedia"
                  target="_blank"
                  class="btn-al btn-al-lg btn-al-celeste"
                >
                  <strong>{{ multimedia[0].desc_button_multimedia }}</strong></a
                >
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="cotitrack-contenido extranet-contenido">
              <div
                :class="[
                  'embed-responsive',
                  isVerticalMedia(multimedia[0].link_multimedia)
                    ? 'embed-responsive-9by16 multimedia-embed-vertical'
                    : 'embed-responsive-16by9',
                ]"
              >
                <iframe
                  class="embed-responsive-item"
                  :src="convertToEmbed(multimedia[0].link_multimedia)"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { getMultimediaInfo } from '@/service/multimedia.service.js';
import { config_settings } from '@/config.js';

export default {
  name: 'MultimediaModule',
  data() {
    return {
      multimedia: [],
    };
  },
  methods: {
    getMultimediaData() {
      getMultimediaInfo()
        .then(response => {
          console.log('📌 Datos recibidos desde el backend:', response.data);
          this.multimedia = response.data;
        })
        .catch(error => {});
    },
    ensureMediaUrl(u) {
      if (!u || typeof u !== 'string') return '';
      const s = u.trim();
      if (!s) return '';
      if (s.startsWith('//')) return 'https:' + s;
      if (/^http:\/\//i.test(s)) return s.replace(/^http:\/\//i, 'https://');
      return s;
    },

    isVerticalMedia(url) {
      if (!url || typeof url !== 'string') return false;
      const raw = url.trim().toLowerCase();
      // Shorts/Reels/TikTok y formatos típicamente verticales
      return /shorts|reel|tiktok|instagram\.com\/reel|youtube\.com\/shorts|youtu\.be\/.+\/shorts/.test(raw);
    },

    convertToEmbed(url) {
      if (!url || typeof url !== 'string') return '';
      const raw = url.trim();
      if (!raw) return '';

      // YouTube: ya viene como embed (incl. youtube-nocookie)
      if (/youtube\.com\/embed\//i.test(raw) || /youtube-nocookie\.com\/embed\//i.test(raw)) {
        return this.ensureMediaUrl(raw);
      }

      // Vimeo reproductor oficial
      if (/player\.vimeo\.com\/video\//i.test(raw)) {
        return this.ensureMediaUrl(raw);
      }

      // Dailymotion embed
      if (/dailymotion\.com\/embed\/video\//i.test(raw)) {
        return this.ensureMediaUrl(raw);
      }

      let videoId = '';

      // YouTube: watch (incl. m.youtube.com, parámetros extra)
      if (/youtube\.com\/watch/i.test(raw) && raw.includes('v=')) {
        try {
          const qIndex = raw.indexOf('?');
          if (qIndex !== -1) {
            const params = new URLSearchParams(raw.slice(qIndex + 1).split('#')[0]);
            videoId = params.get('v') || '';
          }
        } catch (e) {
          /* ignore */
        }
        if (!videoId && raw.includes('watch?v=')) {
          videoId = raw.split('watch?v=')[1].split('&')[0].split('#')[0];
        }
        if (videoId) return 'https://www.youtube.com/embed/' + videoId;
      }

      // YouTube: youtu.be
      if (/youtu\.be\//i.test(raw)) {
        videoId = raw.split('youtu.be/')[1].split(/[?&#/]/)[0];
        if (videoId) return 'https://www.youtube.com/embed/' + videoId;
      }

      // YouTube: Shorts / Live
      const ytShortOrLive = raw.match(
        /youtube\.com\/(?:shorts|live)\/([a-zA-Z0-9_-]+)/i,
      );
      if (ytShortOrLive && ytShortOrLive[1]) {
        return 'https://www.youtube.com/embed/' + ytShortOrLive[1];
      }

      // Vimeo: página pública → player
      const vimeoMatch = raw.match(
        /vimeo\.com\/(?:channels\/[^/]+\/|groups\/[^/]+\/videos\/|video\/)?(\d+)/i,
      );
      if (vimeoMatch && vimeoMatch[1]) {
        return 'https://player.vimeo.com/video/' + vimeoMatch[1];
      }

      // Dailymotion: página o acortado dai.ly
      let dm = raw.match(/dailymotion\.com\/video\/([a-zA-Z0-9]+)/i);
      if (dm && dm[1]) {
        return 'https://www.dailymotion.com/embed/video/' + dm[1];
      }
      dm = raw.match(/dai\.ly\/([a-zA-Z0-9]+)/i);
      if (dm && dm[1]) {
        return 'https://www.dailymotion.com/embed/video/' + dm[1];
      }

      // Cualquier otra URL absoluta (Wistia, Loom, embed propio, etc.)
      if (/^https?:\/\//i.test(raw) || raw.startsWith('//')) {
        return this.ensureMediaUrl(raw);
      }

      return raw;
    },
  },
  created() {
    this.getMultimediaData();
  },
};
</script>

<style scoped lang="scss" src="./MultimediaModule.scss"></style>
